module.exports = __webpack_public_path__ + "img/5000.8529ef5e.png";